export default {
      id: "arrows-usage",
      viewBox: "0 0 8 12",
      url: __webpack_public_path__ + "app/svg/sprite.svg#arrows",
      toString: function () {
        return this.url;
      }
    }